module.exports = __webpack_public_path__ + "img/gongjing.2a29df6c.png";